// extracted by mini-css-extract-plugin
export default {"btn":"btnSmall_btn__58fbs","icon":"btnSmall_icon__r0Li7","fixed-width":"btnSmall_fixed-width__Ni8wv"};